/**
 * Per-product quotation selection (tier tab `liteQuotation.isSelected` is separate).
 * Single source of truth: `product.isSelected`.
 */

/** Whether this product row counts toward area total / save payload / 3D. */
export function isProductChosen(product: any): boolean {
	if (!product) return false;
	if (product.isSelected === true) return true;
	if (product.isSelected === false) return false;
	// Legacy persisted rows / in-flight migrations
	if (product.userSelection === false) return false;
	if (product.isProductSelected === true) return true;
	if (product._explorerToggled === true && product.userSelection === true) return true;
	return false;
}

/** User touched this row in explorer — do not overwrite from default/quotation merge. */
export function isExplorerSelectionLocked(product: any): boolean {
	if (!product) return false;
	return !!(product.explorerAnchor || product._explorerAnchor || product._explorerToggled);
}

export function readExplorerAnchor(product: any): boolean {
	return !!(product?.explorerAnchor || product?._explorerAnchor);
}

export function applyProductSelection(
	product: any,
	selected: boolean,
	options?: { explorerAnchor?: boolean }
): any {
	const next: any = { ...product, isSelected: selected };
	if (options?.explorerAnchor !== undefined) {
		next.explorerAnchor = options.explorerAnchor;
	}
	delete next.isProductSelected;
	delete next.userSelection;
	delete next._explorerToggled;
	delete next._explorerAnchor;
	return next;
}

/** Normalize legacy flags onto `isSelected` and strip duplicates. */
export function normalizeProductSelectionFields(product: any): any {
	if (!product || typeof product !== 'object') return product;
	const isSelected = isProductChosen(product);
	const explorerAnchor = readExplorerAnchor(product);
	const next = applyProductSelection(product, isSelected, { explorerAnchor });
	return next;
}
